module.exports = __webpack_public_path__ + "static/media/southtyrol.659c31e0.svg";